import { retry } from "@reduxjs/toolkit/dist/query/react";

import type { IPaymentReceipt } from "./types";
import { standardRetryingRequestOptions } from "../api/retrying";
import { axiosBaseQuery } from "../api/baseQuery";
import { rtkqApi } from "../api/rtkqApi";
import type { RootState } from "../../store";

export const receiptsApi = rtkqApi.injectEndpoints({
  endpoints: build => ({
    getReceipts: build.query<
      IPaymentReceipt[],
      {
        receiptId: string;
      }
    >({
      queryFn: async (params, api) => {
        const makeQuery = retry(
          axiosBaseQuery({ baseUrl: "https://www.litres.ru" }),
          { ...standardRetryingRequestOptions }
        );
        const response = await makeQuery(
          {
            url: `/receipt/?mm=${params.receiptId}`,
            method: "GET",
            headers: {
              Authorization: (api.getState() as RootState).foundationUser.SID,
              cookie: `SID=${(api.getState() as RootState).foundationUser.SID};`,
            },
          },
          api,
          {}
        );

        if (response.error) {
          return {
            error: response.error,
          };
        }

        return {
          data: response.data as IPaymentReceipt[],
        };
      },
    }),
  }),
});
